export function formatDuration(secondsInput: number | null | undefined): string {
  if (secondsInput === null || secondsInput === undefined || isNaN(Number(secondsInput))) {
    return '0s'
  }
  const totalSeconds = Math.max(0, Number(secondsInput))
  if (totalSeconds < 60) {
    // Under a minute → show seconds with rounding to 1 decimal if <10s
    return totalSeconds < 10 ? `${Math.round(totalSeconds * 10) / 10}s` : `${Math.round(totalSeconds)}s`
  }
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = Math.round(totalSeconds % 60)
  if (minutes < 60) {
    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`
  }
  const hours = Math.floor(minutes / 60)
  const remMinutes = minutes % 60
  return remMinutes > 0 ? `${hours}h ${remMinutes}m` : `${hours}h`
}

